module.exports = {
  SYSTEM_EVENT_LOG_TYPE: {
    SNS_PUBLISH: 'SNS_PUBLISH',
    SQS_MESSAGE: 'SQS_MESSAGE'
  },
  SYSTEM_EVENT_STATUS: {
    NEW: 'NEW',
    RECEIVED: 'RECEIVED',
    PROCESSED: 'PROCESSED',
    PROCESSING_ERROR: 'PROCESSING_ERROR'
  }
};
